import React from "react";
import IncentivesWidget from "./IncentivesWidget";

// We need this wrapper in order to be able to use hooks within rails
const IncentivesWidgetWrapper = props => <IncentivesWidget {...props} />;

export default IncentivesWidgetWrapper;
